import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { ConstuntivoVolumiStorargeModel as ConstuntivoVolumiStorageModel } from "src/models/ConsuntivoVolumiModel";
import { DesignServicesModel } from "src/models/DesignServicesModel";
import { FilterAbstractModel } from "src/models/FilterAbstractModel";
import { LocationModel } from "src/models/LocationModel";

@Component({
  selector: "app-location-filter",
  templateUrl: "./location-filter.component.html",
  styleUrls: ["./location-filter.component.scss"],
})
export class LocationFilterComponent implements OnInit {
  @Input() locationDataInput: [] = [];
  @Input() locationSelected: LocationModel = new LocationModel();
  @Output() onLocationChange = new EventEmitter();
  @Input() filterStorageKey: string = '';
  
  constructor() {}

  ngOnInit() {
    if (JSON.parse(sessionStorage.getItem(this.filterStorageKey))) {
      const filterStorage: ConstuntivoVolumiStorageModel = JSON.parse(
        sessionStorage.getItem(this.filterStorageKey)
      );
      this.locationSelected = filterStorage.location;
    }
  }

  handleLocationChange = (event) => {
    this.onLocationChange.emit(event.value);
  };
}
